<template>
  <div class="reader_right" @mouseup="clearSelelct">
    <div class="cover flex-col">
      <div class="toolbarwrap" style="position: relative">
        <div class="toolbar flex-grow1">
          <div
            :class="['barItem', { active: originType === 0 }]"
            @click="changeOrigintype(0)"
          >
            书影阅读
          </div>
<!--          <div
            :class="originType === 1 ? 'active' : ''"
            @click="changeOrigintype(1)"
          >
            文本阅读
          </div>-->
          <div
            :class="['barItem barItemLast', { active: originType === 2 }]"
            @click="changeOrigintype(2)"
          >
            对照阅读
          </div>
          <div class="bottombar">
            <div class="page">
              <div
                :class="currentIndex === 0 ? 'prepage disable' : 'prepage'"
                @click="handlePre"
              >
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="pagenum" style="display: flex">
                <div><el-select class="custom-select" style="width: 80px;" v-model="currentIndexBox" filterable @change="changeNum">
                  <el-option
                    v-for="(item,index) in pageArr"
                    :key="index"
                    :label="index+1"
                    :value="index+1">
                  </el-option>
                </el-select></div>

                <div style="margin: 0 5px">/</div>
                <div>{{ total }}</div>
              </div>
              <div
                :class="
                  currentIndex + 1 === total ? 'nextpage disable' : 'nextpage'
                "
                @click="handleNext"
              >
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="scale">
              <!--              <img
                              src="@/assets/img/icon_zoomout.png"
                              alt=""
                              @click="handleZoomOut"
                            />-->
              <i class="el-icon-zoom-out" style="font-size: 18px" @click="handleZoomOut"></i>
              <div class="pagenum">
                <span>{{ (ratio * 100).toFixed(0) }}</span
                >%
              </div>
              <!--              <img
                              src="@/assets/img/icon_zoomin.png"
                              alt=""
                              @click="handleZoomIn"
                            />-->
              <i class="el-icon-zoom-in" style="font-size: 18px" @click="handleZoomIn"></i>
            </div>
            <div class="full">
              <!-- <div class="num">1:1</div> -->
              <!--              <img
                              src="@/assets/img/icon_full.png"
                              alt=""
                              @click="isShowFull = true"
                            />-->
              <i class="el-icon-full-screen" style="font-size: 18px"  @click="isShowFull = true"></i>
            </div>
          </div>
        </div>
        <div class="toolbar flex-grow1" v-if="originType!== 0">
          <template v-if="isHorizontal">
            <div
              :class="['barItem', { active: isUseEmpty && isHorizontal}]"
              @click="showEmpty"
              :style="!isHorizontal ? `color: #999999;cursor:default` : ''"
            >
              分词与词性(标签)
            </div>
            <div
              :class="['barItem', { active: isUseColor}]"
              @click="showColor"
            >
              分词与词性(颜色)
            </div>
            <div
              :class="['barItem', { active: isShowNer}]"
              @click="showNer"
            >
              实体标记
            </div>
          </template>
          <div
            :class="['barItem', { active: isShowPunc}]"
            @click="showPunc"
          >
            句读
          </div>
          <div
            :class="['barItem', { active: isShowPunc1}]"
            @click="showPunc1"
          >
            标点
          </div>
          <div
            @click="handleHorizontal"
            :class="['barItem', { active: isHorizontal}]"
          >
            横向阅读
          </div>
          <div
            @click="handleHorizontal"
            :class="['barItem', { active: !isHorizontal}]"
          >
            纵向阅读
          </div>
          <div class="bottombar" style="right: -10px">

            <div class="scale">
              <!--              <img
                              src="@/assets/img/icon_zoomout.png"
                              alt=""
                              @click="handleRightZoomOut"
                            />-->
              <i class="el-icon-zoom-out" style="font-size: 18px;margin-left: 10px" @click="handleRightZoomOut"></i>
              <div class="pagenum">
                <span>{{ (rightRatio * 100).toFixed(0) }}</span
                >%
              </div>
              <!--              <img
                              src="@/assets/img/icon_zoomin.png"
                              alt=""
                              @click="handleRightZoomIn"
                            />-->
              <i class="el-icon-zoom-in" style="font-size: 18px" @click="handleRightZoomIn"></i>

            </div>
            <div class="style" style="margin-right: 5px">
              <div :class="isBold ? 'active' : ''" @click="setBold">
                <b>B</b>
              </div>
              <!--              <div :class="isItalic ? 'active' : ''" @click="setItalic">
                              <img src="@/assets/img/italic.svg" alt="" />
                            </div>-->
            </div>
          </div>
          <!-- <div :class="isUseEmpty ? 'active' : ''" @click="showEmpty">标签类型</div>
          <div :class="isUseColor ? 'active' : ''" @click="showColor">控制颜色</div> -->
        </div>
        <!-- flex-direction: row-reverse; -->
        <div
          class="color"
          style="position: absolute; left: 50%; top: 56px; display: flex"
          v-show="isUseColor"
        >
          <div
            v-for="(item, index) in color"
            :key="index"
            style="margin-left: 5px"
          >
            <span>{{ index }}</span>
            <span
              :style="`display: inline-block;width: 10px;height: 10px;background:${item}`"
            ></span>
          </div>
        </div>
      </div>
      <div
        class="flex flex-grow1 relative contentBox"
        v-loading="loading"
        id="contentBox"
      >
        <div class="origintext flex-grow1" v-show="originType !== 1" ref="container">
          <div
            id="picBox"
            ref="picBox"
            class="flex-grow1 picBox"
            v-show="isOperaText"
            @mouseenter="showIcon=true"
            @mouseleave="showIcon=false"
          >
            <div
              @mouseup="getSelectedElement"
              @contextmenu.prevent="handleRightClick"
              :style="{
                position: 'relative',
                width: currentRow.picWidth * ratio + 'px',
                height: currentRow.picHeight * ratio + 'px',
              }"
            >
<!--              <img
                id="srcImg"
                class="srcImg"
                v-show="currentPagePic"
                :src="currentPagePic"
                @click="cancelSel"
              />-->
              <el-image
                id="srcImg"
                class="srcImg"
                v-show="currentPagePic"
                :src="currentPagePic"
                @click="cancelSel"
                :preview-src-list="[currentPagePic]">
              </el-image>
              <div v-for="(item, index) in currentBox" :key="index">
                <div
                  v-for="(pred, pid) in item.preds"
                  :key="index + pid"
                  :class="inputClass(pred.type)"
                  :style="{
                    position: 'absolute',
                    left: pred.left * ratio + 'px',
                    top: pred.top * ratio + 'px',
                    width: pred.width * ratio + 'px',
                    height: pred.height * ratio + 'px',
                    background: computedBgColorPic(pred.id),
                  }"
                >
                  <div
                    class="unHorizontal"
                    :id="`pic${pred.id}`"
                    :data-id="pred.id"
                    style="color: transparent"
                  >
                    {{pred.pred[0]}}
                  </div>
                </div>
              </div>
<!--              <div v-if="currentBox.length===0" style="margin-top: 100px">
                <el-empty description="本书暂无对照文本"></el-empty>
              </div>-->
            </div>
            <div
              :class="currentIndex === 0 ? 'prepage disable' : 'prepage'"
              @click="handlePre"
              style="position: absolute;top:45%;left: 10px;color: #ccc"
              v-show="showIcon"
            >
              <i class="el-icon-arrow-left" style="font-size: 40px;"></i>
            </div>
            <div
              v-show="showIcon"
              :class="
                  currentIndex + 1 === total ? 'nextpage disable' : 'nextpage'
                "
              @click="handleNext"
              style="position: absolute;top:45%;right: 10px;color: #ccc"
            >
              <i class="el-icon-arrow-right" style="font-size: 40px"></i>
            </div>
          </div>

        </div>
        <!--  style="height: calc(100vh - 16.5rem);background-color: #F8F7F3;" -->
        <div
          class="text-opera flex-grow1"
          v-show="originType !== 0"
          ref="opearBox"
          id="opearBox"
          style="background-color: #f8f7f3"
        >
          <div
            class="rightInner"
            :style="{
              'font-style': isItalic ? 'italic' : '',
              'font-weight': isBold ? '700' : '500',
              'font-family':'KaiTi, KaiTi_GB2312, STKaiti, 楷体, serif',

            }"
          >
            <!-- 横向阅读 -->
            <div
              v-if="isHorizontal"
              class="horizontal_wrap"
              @contextmenu.prevent="handleRightClick"
              @mouseup="getSelectedElement"
            >
              <div
                v-for="(item, index) in passageArr"
                :key="index"
                class="flex"
                v-if="false"
              >
                <div
                  v-for="(pred, pid) in item"
                  :key="pid"
                  class="inputDeepBorder flex horizontal_flex"
                  style="position: relative"
                >
                  <div
                    class="horizontal"
                    :id="`text${pred.id}`"
                    :data-id="pred.id"
                    :style="{
                      background: computedBgColor(pred.id),
                      'font-size': 20 * rightRatio + 'px',
                      'position':'relative'
                    }"
                  >
                    {{ mainText[pred.id] }}
                    <!-- 实体标记 -->
                                      <span
                                        title="书名"
                                        style="
                                          position: absolute;
                                          left: 0;
                                          bottom: 0px;
                                          width: 100%;
                                          border-bottom:dashed;
                                          color: red;
                                        "
                                        v-if="
                                          nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='shuming')
                                        "
                                      ></span>
                                      <span
                                        title="时间"
                                        style="
                                          position: absolute;
                                          left: 0;
                                          bottom: 0px;
                                          width: 100%;
                                          border-bottom: solid;
                                          color: red;
                                        "
                                        v-if="
                                          nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='date')
                                        "
                                      ></span>
                                      <span
                                        title="人名"
                                        style="
                                          position: absolute;
                                          left: 0;
                                          bottom: 0px;
                                          width: 100%;
                                          border-bottom: dotted;
                                          color: red;
                                        "
                                        v-if="
                                           nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='peop')
                                        "
                                      ></span>
                                      <span
                                        title="地点"
                                        style="
                                          position: absolute;
                                          left: 0;
                                          bottom: 0px;
                                          width: 100%;
                                          border-bottom: double;
                                          color: red;
                                        "
                                        v-if="
                                           nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='tpn')
                                        "
                                      ></span>
                                      <span
                                        title="官职"
                                        style="
                                          position: absolute;
                                          left: 0;
                                          bottom: -12px;
                                          width: 100%;
                                          color: red;
                                          font-size: 20px;
                                          overflow: hidden;
                                        "
                                        v-if="
                                          nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='offi')
                                        "
                                        >~~~~~~~~</span
                                      >
                  </div>
                  <!-- 标签类型 -->
                  <span
                    class="horizontal_ju"
                    :style="{ 'font-size': 20 * rightRatio + 'px' }"
                    v-if="isUseEmpty && posEndObj[pred.id]"
                    >/{{ posEndObj[pred.id] }}</span
                  >
                  <!-- 句读 -->
                  <span
                    class="horizontal_ju"
                    :style="{ 'font-size': 20 * rightRatio + 'px' }"
                    v-if="puncArr[pred.id] && isShowPunc"
                    >。</span
                  >
                  <!-- 标点 -->
                  <span
                    class="horizontal_ju"
                    :style="{ 'font-size': 20 * rightRatio + 'px'}"
                    v-if="puncArr[pred.id] > -1 && isShowPunc1"
                    >{{ puncArr[pred.id].text }}</span
                  >
                  <!-- 实体标记 -->
<!--                  <span
                    title="书名"
                    style="
                      position: absolute;
                      left: 0;
                      bottom: 0px;
                      width: 100%;
                      border-bottom:dashed;
                      color: red;
                    "
                    v-if="
                      nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='shuming')
                    "
                  ></span>
                  <span
                    title="时间"
                    style="
                      position: absolute;
                      left: 0;
                      bottom: 0px;
                      width: 100%;
                      border-bottom: solid;
                      color: red;
                    "
                    v-if="
                      nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='date')
                    "
                  ></span>
                  <span
                    title="人名"
                    style="
                      position: absolute;
                      left: 0;
                      bottom: 0px;
                      width: 100%;
                      border-bottom: dotted;
                      color: red;
                    "
                    v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='peop')
                    "
                  ></span>
                  <span
                    title="地点"
                    style="
                      position: absolute;
                      left: 0;
                      bottom: 0px;
                      width: 100%;
                      border-bottom: double;
                      color: red;
                    "
                    v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='tpn')
                    "
                  ></span>
                  <span
                    title="官职"
                    style="
                      position: absolute;
                      left: 0;
                      bottom: -12px;
                      width: 100%;
                      color: red;
                      font-size: 20px;
                      overflow: hidden;
                    "
                    v-if="
                      nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='offi')
                    "
                    >~~~~~~~~</span
                  >-->
                </div>
              </div>
              <div
                v-for="(pred, pid) in Array.from(mainText)"
                :key="pid"
                class="inputDeepBorder flex horizontal_flex"
                style="position: relative"
              >
                <div
                  class="horizontal"
                  :id="`text${pid + 1}`"
                  :data-id="pid + 1"
                  :style="{
                    background: computedBgColor(pid + 1),
                    'font-size': 20 * rightRatio + 'px',
                    'position':'relative'
                  }"
                >
                  {{ pred }}
                  <!-- 实体标记 -->
                                  <span
                                    title="书名"
                                    style="
                                      position: absolute;
                                      left: 0;
                                      bottom: 0px;
                                      width: 100%;
                                      border-bottom:dashed ;
                                      color: red;
                                    "
                                    v-if="
                                      nerArr[pid + 1] && (nerArr[pid + 1]==='shuming') && isShowNer
                                    "
                                  ></span>
                                  <span
                                    title="时间"
                                    style="
                                      position: absolute;
                                      left: 0;
                                      bottom: 0px;
                                      width: 100%;
                                      border-bottom: solid;
                                      color: red;
                                    "
                                    v-if="
                                      nerArr[pid + 1] && (nerArr[pid + 1]==='date') && isShowNer
                                    "
                                  ></span>
                                  <span
                                    title="人名"
                                    style="
                                      position: absolute;
                                      left: 0;
                                      bottom: 0px;
                                      width: 100%;
                                      border-bottom: dotted;
                                      color: red;
                                    "
                                    v-if="
                                      nerArr[pid + 1] && (nerArr[pid + 1]==='peop') && isShowNer
                                    "
                                  ></span>
                                  <span
                                    title="地址"
                                    style="
                                      position: absolute;
                                      left: 0;
                                      bottom: 0px;
                                      width: 100%;
                                      border-bottom: double;
                                      color: red;
                                    "
                                    v-if="
                                      nerArr[pid + 1] && (nerArr[pid + 1]==='tpn') && isShowNer
                                    "
                                  ></span>
                                  <span
                                    title="官职"
                                    style="
                                      position: absolute;
                                      left: 0;
                                      bottom: -12px;
                                      width: 100%;
                                      color: red;
                                      font-size: 20px;
                                      overflow: hidden;
                                    "
                                    v-if="
                                      nerArr[pid + 1] && (nerArr[pid + 1]==='offi') && isShowNer
                                    "
                                    >~~~~~~~~</span
                                  >
                </div>
                <!-- 标签类型 -->
                <span
                  class="horizontal_ju"
                  :style="{ 'font-size': 20 * rightRatio + 'px' }"
                  v-if="isUseEmpty && posEndObj[pid + 1]"
                  >/{{ posEndObj[pid + 1] }}</span
                >
                <!-- 句读 -->
                <span
                  class="horizontal_ju"
                  :style="{ 'font-size': 20 * rightRatio + 'px' }"
                  v-if="puncArr[pid + 1] && isShowPunc"
                  >。</span
                >
                <!-- 标点 -->
                <span
                  class="horizontal_ju"
                  :style="{ 'font-size': 20 * rightRatio + 'px' }"
                  v-if="puncArr[pid + 1] && isShowPunc1"
                  >{{ puncArr[pid + 1].text }}</span
                >
                <!-- 实体标记 -->
<!--                <span
                  title="书名"
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    width: 100%;
                    border-bottom:dashed ;
                    color: red;
                  "
                  v-if="
                    nerArr[pid + 1] && (nerArr[pid + 1]==='shuming') && isShowNer
                  "
                ></span>
                <span
                  title="时间"
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    width: 100%;
                    border-bottom: solid;
                    color: red;
                  "
                  v-if="
                    nerArr[pid + 1] && (nerArr[pid + 1]==='date') && isShowNer
                  "
                ></span>
                <span
                  title="人名"
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    width: 100%;
                    border-bottom: dotted;
                    color: red;
                  "
                  v-if="
                    nerArr[pid + 1] && (nerArr[pid + 1]==='peop') && isShowNer
                  "
                ></span>
                <span
                  title="地址"
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    width: 100%;
                    border-bottom: double;
                    color: red;
                  "
                  v-if="
                    nerArr[pid + 1] && (nerArr[pid + 1]==='tpn') && isShowNer
                  "
                ></span>
                <span
                  title="官职"
                  style="
                    position: absolute;
                    left: 0;
                    bottom: -12px;
                    width: 100%;
                    color: red;
                    font-size: 20px;
                    overflow: hidden;
                  "
                  v-if="
                    nerArr[pid + 1] && (nerArr[pid + 1]==='offi') && isShowNer
                  "
                  >~~~~~~~~</span
                >-->
              </div>
            </div>
            <!-- 纵向阅读 -->
            <div
              v-if="(!isHorizontal)&&(currentBox.length>0)"
              style="position: relative;margin: 0 auto;background-color: #fff"
              :style="{
                width: currentRow.picWidth * rightRatio + 'px',
                height: currentRow.picHeight * rightRatio + 'px',
              }"
              @contextmenu.prevent="handleRightClick"
              @mouseup="getSelectedElement"

            >
              <div v-for="(item, index) in currentBox" :key="index">
                <!--   width: item.preds[0].width + 'px',  left: item.preds[0].left * rightRatio + 'px',-->
                <div
                  v-for="(pred, pid) in item.preds"
                  :key="index + pid"
                  :class="inputClass(pred.type)"
                  :style="{
                    position: 'absolute',
                    left: pred.left * rightRatio + 'px',
                    top: pred.top * rightRatio + 'px',
                    width: pred.width * rightRatio + 'px',
                    height: pred.height * rightRatio + 'px',
                    background: computedBgColor(pred.id),
                }"
                >
                  <div
                    class="unHorizontal horizontal-cursor"
                    :id="`text${pred.id}`"
                    :data-id="pred.id"
                    :style="{
                      'font-size': pred.font * rightRatio + 'px',
                      'line-height': pred.height * rightRatio + 'px',
                      'position':'relative'
                    }"
                  >
                    {{ pred.pred[0] }}
                    <!-- 实体标记 -->
                    <span
                      title="书名"
                      style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left:dashed ;
                      color: red;
                    "
                      v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='shuming')
                    "
                    ></span>
                    <span
                      title="时间"
                      style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left:solid ;
                      color: red;
                    "
                      v-if="
                      nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='date')
                    "
                    ></span>
                    <span
                      title="人名"
                      style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left: dotted;
                      color: red;
                    "
                      v-if="
                        nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='peop')
                    "
                    ></span>
                    <span
                      title="地点"
                      style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left: double;
                      color: red;
                    "
                      v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='tpn')
                    "
                    ></span>
                    <span
                      title="官职"
                      style="
                      position: absolute;
                      left: -25px;
                      top: 0;
                      height: 100%;
                      color: red;
                      writing-mode: vertical-lr;
                      font-size: 20px;
                      overflow: hidden;
                    "
                      v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='offi')
                    "
                    >~~~~~~~~</span
                    >
                  </div>
                  <!-- 句读 -->
                  <span
                    class="ju"
                    :style="{
                      'font-size': pred.font * rightRatio + 'px',
                      'line-height': pred.height * rightRatio + 'px',
                      right: pred.juRigth * rightRatio + 'px',
                      bottom: pred.juTop * rightRatio + 'px',
                    }"
                    v-if="puncArr[pred.id] && isShowPunc"
                    >。</span
                  >
                  <!-- 标点  -->
                  <span
                    class="ju"
                    :style="{
                      'font-size': pred.font * rightRatio + 'px',
                      'line-height': pred.height * rightRatio + 'px',
                      right: pred.juRigth * rightRatio + 'px',
                      bottom: pred.juTop * rightRatio + 'px',
                    }"
                    v-if="puncArr[pred.id] && isShowPunc1"
                    >{{ puncArr[pred.id].text }}</span
                  >
                  <!-- 实体标记 -->
<!--                  <span
                    title="书名"
                    style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left:dashed ;
                      color: red;
                    "
                    v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='shuming')
                    "
                  ></span>
                  <span
                    title="时间"
                    style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left:solid ;
                      color: red;
                    "
                    v-if="
                      nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='date')
                    "
                  ></span>
                  <span
                    title="人名"
                    style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left: dotted;
                      color: red;
                    "
                    v-if="
                        nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='peop')
                    "
                  ></span>
                  <span
                    title="地点"
                    style="
                      position: absolute;
                      left: -7px;
                      top: 0;
                      height: 100%;
                      border-left: double;
                      color: red;
                    "
                    v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='tpn')
                    "
                  ></span>
                  <span
                    title="官职"
                    style="
                      position: absolute;
                      left: -25px;
                      top: 0;
                      height: 100%;
                      color: red;
                      writing-mode: vertical-lr;
                      font-size: 20px;
                      overflow: hidden;
                    "
                    v-if="
                       nerArr[pred.id]&& isShowNer&&(nerArr[pred.id]==='offi')
                    "
                    >~~~~~~~~</span
                  >-->
                </div>
              </div>
            </div>
            <div v-if="(!isHorizontal)&&(currentBox.length===0)" style="margin: 100px auto">
              <el-empty v-if='originType === 2' description="本书暂无对照文本"></el-empty>
              <el-empty v-if='originType === 1' description="本书暂无文本"></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-card
      class="rightMenu"
      v-show="visibleRightMenu"
      :style="{
        top: menuPosition.y + 'px',
        left: menuPosition.x + 'px',
        'z-index': 10,
      }"
    >
      <div ref="rightMenu" class="rightMenu_inner">
<!--         <div @click="handleCopyText">复制</div>-->
        <div @click="handleCopyBookdetail">复制引用</div>
        <!-- <div @click="bookMarkVisible = true; bookMarkForm.text = selectedText">添加书签</div> -->
        <div
          @click="
            noteVisible = true;
            noteForm.text = selectedText;
          "
        >
          添加笔记
        </div>
        <div @click="problemVisible = true;problemForm.selectedText = selectedText">反馈问题</div>
        <!-- <div @click="goPartSearch">拼字输入法</div> -->
      </div>
    </el-card>
    <el-dialog title="添加书签" :visible.sync="bookMarkVisible">
      <el-form :model="bookMarkForm" label-width="70px">
        <el-form-item label="书签名：">
          <el-input v-model="bookMarkForm.text"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="bookMarkForm.remark"
            type="textarea"
            no-resize
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bookMarkVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMark">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加笔记" :visible.sync="noteVisible">
      <el-form :model="noteForm" label-width="82px">
        <el-form-item label="原文：">
          <el-input v-model="noteForm.text" readonly></el-input>
        </el-form-item>
        <el-form-item label="笔记：">
          <el-input
            v-model="noteForm.remark"
            type="textarea"
            no-resize
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noteVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNote">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="反馈问题" :visible.sync="problemVisible">
      <el-form :model="problemForm" label-width="82px">
        <el-form-item label="原文：">
          <el-input v-model="problemForm.selectedText" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="problemForm.remark"
            type="textarea"
            no-resize
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="problemVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProblem">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="successVisible">
      <div class="success_dialog">
        <span>操作成功，</span>
        <el-link type="primary" @click="goCenter">去查看</el-link>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="successVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <div class="full_wrapper" v-if="isShowFull">
      <div class="content_img" ref="dragArea">
        <div
          :style="{
            position: ' relative',
            top: currentY + 'px',
            left: currentX + 'px',
            width: currentRow.picWidth * ratio + 'px',
            height: currentRow.picHeight * ratio + 'px',
          }"
          ref="draggableElement"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <img
            style="width: 100%; height: 100%; object-fit: contain"
            :src="currentPagePic"
          />
        </div>
      </div>

      <div class="bottombar">
        <div class="inner">
          <div class="scale" style="display: flex">
            <i class="el-icon-zoom-out" style="font-size: 18px" @click="handleZoomOut"></i>
            <div class="pagenum" style="margin: 0 10px">
              <span>{{ (ratio * 100).toFixed(0) }}</span
              >%
            </div>
            <i class="el-icon-zoom-in" style="font-size: 18px" @click="handleZoomIn"></i>
          </div>
        </div>
      </div>
      <div  style="position: absolute;top:5px;right: 15px;color: #fff;z-index: 10001" @click="isShowFull=false">
        <i class="el-icon-close" style="font-size: 50px"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getReadSinglePage, addBookNote, addBookQa, read, bookInfo,copyRecord } from '@/api/api'
import variables from '@/assets/variables.less'
import Big from 'big.js'
import OpenCC from 'opencc-js'
import fa from "element-ui/src/locale/lang/fa";
const converter = OpenCC.Converter({ from: 'tw', to: 'cn' })

export default {
  name: 'RightContainer',
  props: ['searchText', 'pageArr'],
  data () {
    return {
      showIcon:false,
      bookId: null,
      bookName: '',
      pageList: {},
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 1
      },
      // 总条数
      total: 0,
      baseUrl: window.__baseUrl__,
      isResizing: false,
      containerWidth: 0,
      containerHeight: 0,
      imageSize: {
        width: 0,
        height: 0
      },
      currentPagePic: '',
      contentDelta: [],
      contentChangeDelta: [],
      isHorizontal: false,
      isOperaText: true,
      rightOpera: {},
      isLeftTree: true,
      isShowEditPic: true,
      currentBox: [],
      splitPicList: [],
      currentSpiltIndex: [],
      currentSpiltIndexStr: '',
      isSort: false,
      currentFont: '',
      selMap: {},
      selNewMap: {},
      isNew: false,
      isSortChange: false,
      pageSortMap: {
        sort: {},
        font: {}
      },
      newMouseDown: false,
      currentRow: {},
      ocrStatusText: {
        0: 'OCR未开始',
        10: 'OCR进行中',
        20: 'OCR完成',
        30: 'OCR发送失败',
        35: 'OCR识别失败',
        40: '文字调整',
        50: '段落调整',
        60: '已完成'
      },
      ocrStatusOptions: [
        {
          value: 0,
          label: '待完成'
        },
        {
          value: 60,
          label: '已完成'
        }
      ],
      lightChange: '',
      isMerge: false,
      newAreaStartPos: {},
      isDrag: false,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      top: 0,
      left: 0,
      loadingOcr: false,
      updateDelta: [],
      isEdit: false,
      operaList: [],
      operaStackList: [],
      currentStackIndex: 0,
      stackSize: 30,
      isShowRect: false,
      splitImgList: [],
      canvas: null,
      ctx: null,
      ratio: 1,
      rightRatio: 1,
      scalRatio:1,
      isZoom: false,
      rectTypeOptions: [
        { label: '隐藏框', value: 'hidden' },
        { label: '白色框', value: 'white' },
        { label: '深色框', value: 'brown' }
      ],
      rectType: 'hidden',
      currentHighlightColor: '',
      pageId: null,
      currentIndex: 0,
      currentIndexBox: 1,
      // 0书影阅读 1文本阅读 2对照阅读
      originType: 2,
      isDragging: false, // 是否正在拖拽
      startX: 0, // 鼠标初始 X 坐标
      startY: 0, // 鼠标初始 Y 坐标
      currentX: 0, // 图片当前 X 坐标
      currentY: 0, // 图片当前 Y 坐标
      boundary: {}, // 容器边界
      timer: null,
      isShowFull: false,
      visibleRightMenu: false,
      menuPosition: { x: 0, y: 0 },
      bookMarkVisible: false,
      bookMarkForm: {
        text: '',
        remark: ''
      },
      noteVisible: false,
      noteForm: {
        text: '',
        remark: ''
      },
      problemVisible: false,
      problemForm: {
        selectedText:'',
        remark: ''
      },
      selectedTextArr: [],
      puncArr: {},
      isShowPunc: false,
      passageArr: [],
      isShowPunc1: false,
      allText: '',
      searchTextIds: [],
      selectedText: '',
      successVisible: false,
      addFrom:'',
      nerArr: {},
      isShowNer: false,
      isShowPos: false,
      posArr: [],
      posEndArr: [],
      posEndObj: {},
      isUseEmpty: false,
      isUseColor: false,
      color: {
        N: 'rgb(67, 205, 63)',
        T: 'rgb(93, 157, 254)',
        F: 'rgb(255,186,0)',
        V: 'rgb(0,248,255)',

        A: 'rgb(133 89 93)',
        D: 'rgb(195 87 97)',
        M: 'rgb(181 87 195)',
        P: 'rgb(98 78 159)',

        C: 'rgb(78 133 159)',
        Y: 'rgb(68 153 194)',
        U: 'rgb(122 206 188)',
        E: 'rgb(61 160 138)',
        R: 'rgb(126 212 91)',
        W: 'rgb(209 218 71)'
      },
      canvasRatio: 1,
      isBold: window.localStorage.getItem('isBold') == 'true' ? window.localStorage.getItem('isBold') : false,
      isItalic: window.localStorage.getItem('isItalic') == 'true' ? window.localStorage.getItem('isItalic') : false,
      bookInfo: {},
      mainText: '',
      currentSearchText: '',
      searchParams: {},
      keyWordAll: {},
      isShowKeywordHigh: true
    }
  },
  watch: {
    'searchText': {
      handler (val) {
        this.currentSearchText = converter(val)
        this.handleSearch(val)
      }
    },
    pageArr: {
      handler (val) {
        this.total = val.length
        if (val.length > 0) {
          let flag = false
          val.forEach((item, index) => {
            if (item === this.pageId) {
              this.currentIndex = index
              this.currentIndexBox = index+1
              flag = true
              this.$emit('setCurrentIndex', this.currentIndex)
            }
          })
          if (!flag && this.currentIndex === 0) {
            this.pageId = val[0]
            this.$emit('setCurrentIndex', this.currentIndex)
          }
          flag = false
          this.getPageList()
          this.getBookInfo()
        }
      },
      immediate: true
    }
  },
  computed: {
    fa() {
      return fa
    },
    variables () {
      return variables
    },
    /*scale() {
      if (this.imageSize.width === 0 || this.imageSize.height === 0) return 0;
      this.containerWidth = this.$refs.container.clientWidth;
      this.containerHeight = this.$refs.container.clientHeight;
      const containerRatio = this.containerWidth / this.containerHeight;
      const imgRatio = this.imageSize.width / this.imageSize.height;

      if (containerRatio > imgRatio) {
        // 容器更宽，高度方向填满
        this.ratio=this.containerHeight / this.imageSize.height;
        this.rightRatio=this.containerHeight / this.imageSize.height;
      } else {
        // 容器更高，宽度方向填满
        this.ratio= this.containerWidth / this.imageSize.width;
        this.rightRatio= this.containerWidth / this.imageSize.width;
      }
    }*/
  },
  created () {
    if (this.$route.query && this.$route.query.bookId) {
      this.bookId = this.$route.query.bookId
      this.queryParams.bookId = this.bookId
    }
    if (this.$route.query && this.$route.query.bookName) {
      this.bookName = this.$route.query.bookName
    }
    console.log(this.$route.query.pageId)
    if (this.$route.query && this.$route.query.pageId) {
      this.pageId = this.$route.query.pageId
      this.queryParams.pageId = this.bookId
    }

    if (this.$route.query && this.$route.query.search) {
      this.searchParams = JSON.parse(this.$route.query.search)
    }
    if (this.$route.query && this.$route.query.keyWordAll) {
      this.keyWordAll = JSON.parse(this.$route.query.keyWordAll)
    }
    // if (this.$route.query && this.$route.query.keywords) {
    //   this.currentSearchText = this.$route.query.keywords
    // }

    // if (this.$route.query && this.$route.query.juanNum) {
    //   let juanNum = parseInt(this.$route.query.juanNum)
    //   this.queryParams.pageNum = Math.ceil(juanNum / this.queryParams.pageSize)
    //   // this.currentIndex = (juanNum % this.queryParams.pageSize) - 1
    //   this.currentIndex = juanNum

    // }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
    /*this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);*/
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateContainerSize);
  },
  methods: {
    changeNum(val){
      this.currentIndex=val-1
      if (this.pageArr[this.currentIndex]) {
        this.pageId = this.pageArr[this.currentIndex]
        if (this.pageList && this.pageList[this.currentIndex]) {
          this.getDetail(this.pageList[this.currentIndex])
        } else {
          // this.queryParams.pageNum--
          this.getPageList()
        }

        // this.$nextTick(() => {
        // this.resetPic()
        //   this.handleSearch(this.currentSearchText)
        // })

        this.$emit('setCurrentIndex', this.currentIndex)
      }
    },
   /* updateContainerSize() {
      // 根据父容器或窗口大小动态设置
      this.containerWidth = this.$refs.container.clientWidth;
      this.containerHeight = this.$refs.container.clientHeight;
    },*/
    setKeywordHigh () {
     // const searchParams = this.searchParams
      this.searchTextIds = []
      this.selectedTextArr = []
      let keywords=this.keyWordAll.keyWordAll

   /*   let keywords = searchParams.keyword.split(' ')
      // keywords.push(searchParams.keyword)
      if (searchParams.searchType === '1') {
        searchParams.advancedQuery.forEach(item => {
          if (item.type !== 'not') {
            keywords.push(item.keyword)
          }
        })
      } else if (searchParams.searchType === '2') {
        searchParams.nearQuery.forEach(item => {
          if (item.type !== 'not') {
            keywords.push(item.keyword)
          }
        })
      }*/
      console.log(keywords)
      keywords.forEach(item => {
        item = converter(item)
        if (!this.isHorizontal) {
          console.log(this.item)
          console.log(this.allText)
          if (converter(this.allText).indexOf(item) > -1) {
            const indexArr = this.findAdjacentIndexesRegex(converter(this.allText), item)
            console.log(indexArr)
            const len = item.length
            indexArr.forEach(index => {
              for (let i = 1; i <= len; i++) {
                this.searchTextIds.push(index + i)
              }
            })
          }
        } else {
          if (converter(this.mainText).indexOf(item) > -1) {
            const indexArr = this.findAdjacentIndexesRegex(converter(this.mainText), item)
            const len = item.length
            indexArr.forEach(index => {
              for (let i = 1; i <= len; i++) {
                this.searchTextIds.push(index + i)
              }
            })
          }
        }
      })
    },
    handleSearch (val) {
      val = converter(val)
      this.searchTextIds = []
      this.selectedTextArr = []
      if (val.trim() === '') {
        this.$emit('currentSearch', 0)
        return false
      }
      this.isShowKeywordHigh = false
      const keywords = val.split(' ')
      let hasResult = false
      console.log(keywords)
      keywords.forEach(item => {
        if (!this.isHorizontal) {
          if (converter(this.allText).indexOf(item) > -1) {
            this.$emit('currentSearch', 1)
            const indexArr = this.findAdjacentIndexesRegex(converter(this.allText), item)
            const len = item.length
            indexArr.forEach(index => {
              for (let i = 1; i <= len; i++) {
                this.searchTextIds.push(index + i)
              }
            })
            hasResult = true
          }
          // else if (item !== '') {
          //   this.$emit('currentSearch', 2)
          // }
        } else {
          if (converter(this.mainText).indexOf(item) > -1) {
            this.$emit('currentSearch', 1)
            const indexArr = this.findAdjacentIndexesRegex(converter(this.mainText), item)
            const len = item.length
            indexArr.forEach(index => {
              for (let i = 1; i <= len; i++) {
                this.searchTextIds.push(index + i)
              }
            })
            hasResult = true
          }
          // else if (item !== '') {
          //   this.$emit('currentSearch', 2)
          // }
        }
      })
      if (keywords.length && !hasResult) {
        // 没有找到数据
        this.$emit('currentSearch', 2)
      }
    },
    // 监听键盘左右按键
    handleKeydown (event) {
      if (event.key === 'ArrowLeft') {
        this.handlePre()
      } else if (event.key === 'ArrowRight') {
        this.handleNext()
      }
    },
    findAdjacentIndexesRegex (text, target) {
      const regex = new RegExp(target, 'g') // 全局匹配
      let matches = [...text.matchAll(regex)] // 获取所有匹配项
      return matches.map(match => match.index) // 提取索引
    },
    handleClickOutside (event) {
      const refDom = this.$refs.rightMenu
      if (refDom && !refDom.contains(event.target)) {
        this.visibleRightMenu = false
        // 移除全局点击事件监听
        document.removeEventListener('click', this.handleClickOutside)
      }

    },
    clearSelelct (event) {
      const imgDom = document.getElementById('srcImg')
      const opearBox = document.getElementById('opearBox')
      const refDom = this.$refs.rightMenu
      if (imgDom && !imgDom.contains(event.target) && opearBox && !opearBox.contains(event.target) && refDom && !refDom.contains(event.target)) {
        this.selectedTextArr = []
        this.selectedText = ''
        this.visibleRightMenu = false
      }
    },
    getSelectedElement (e) {
      e.preventDefault()
      e.stopPropagation()
      this.selectedTextArr = []
      const selection = window.getSelection()
      this.selectedText = selection.toString()
      console.log(this.selectedText)
      if (selection.rangeCount > 0 && this.selectedText) {
        const anchorNodeId = Number(selection.anchorNode.parentNode.dataset.id) || Number(selection.anchorNode.dataset.id)
        const extentNodeId = Number(selection.extentNode.parentNode.dataset.id) || Number(selection.extentNode.dataset.id)
        if (selection.extentNode.innerText) {
          this.selectedText = this.selectedText + selection.extentNode.innerText
        }
        console.log(anchorNodeId)
        console.log(extentNodeId)
        const startIndex = Math.min(anchorNodeId, extentNodeId)
        const endIndex = Math.max(anchorNodeId, extentNodeId)
        for (let i = startIndex; i <= endIndex; i++) {
          this.selectedTextArr.push(i)
        }
        console.log(this.selectedTextArr)
        let textDoc = document.getElementById(
          'text' + startIndex
        )
        textDoc.focus()
        textDoc.scrollIntoView({ behavior: 'smooth' })
        let picDoc = document.getElementById('pic' + startIndex)
        picDoc.scrollIntoView({ behavior: 'smooth' })
        if (this.selectedText) {
          // this.isShowKeywordHigh = false
          this.menuPosition = { x: e.clientX, y: e.clientY }
          this.visibleRightMenu = true
          //document.addEventListener('click', this.handleClickOutside)
        } else {
          this.visibleRightMenu = false
          //document.removeEventListener('click', this.handleClickOutside)
        }
      }else{
        this.visibleRightMenu = false
      }
    },
    handleCopyText(e){
      let mainText= this.selectedText.replace(/\s/g, '')
      let params=JSON.stringify({
        currentIndex:this.currentIndex + 1,
        text:mainText,
        bookId:this.bookId
      })
      copyRecord({
        param: params,
        operationType:'copy',
        title:'复制'
      }).then(res => {
        if (res.code === 200) {
          this.$message.success("复制成功")
        }
      })
    },
    handleRightClick (e) {
      e.stopPropagation()
      if (this.selectedText) {
        // this.isShowKeywordHigh = false
        this.menuPosition = { x: e.clientX, y: e.clientY }
        this.visibleRightMenu = true
        document.addEventListener('click', this.handleClickOutside)
      } else {
        this.visibleRightMenu = false
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    changeOrigintype (value) {
      this.originType = value
    },
    /** 查询书页列表 */
    getPageList () {
      const _this = this
      _this.loading = true
      try {
        getReadSinglePage({
          bookId: String(this.bookId),
          pageId: String(this.pageId)
        }).then(response => {
          if(response.code===200){
            this.pageList[this.currentIndex] = response.data
            this.getDetail(response.data)
            // _this.total = response.total
            _this.loading = false
            // _this.$emit('getTotal', _this.total)
          }else{
            _this.loading = false
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }

        })
      } catch (error) {
        this.currentBox = []
        this.currentPagePic = ''
      }
    },
    onPicSel (row, column, event) {
      this.resetPic()
      this.getDetail(row)
    },
    handleImgUrl (data) {
      // let arr = data.split('/')
      // let tempBookName = arr[arr.length - 3]
      // arr[arr.length - 3] = encodeURIComponent(tempBookName)
      // return arr.join('/')
      return 'data:image/png;base64,' + data
    },
    parseUnicode(str) {
      try {
        return JSON.parse('"' + str.replace(/\"/g, '\\"') + '"');
      } catch (e) {
        return str;
      }
    },
    processSurrogatePairs(str) {
      return str.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, function(pair) {
        const high = pair.charCodeAt(0);
        const low = pair.charCodeAt(1);
        const codePoint = (high - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
        return String.fromCodePoint(codePoint);
      });
    },
    getImageDimensions(base64String) {
      return new Promise((resolve, reject) => {
        const img = new Image()

        img.onload = function() {
          resolve({
            width: this.naturalWidth,
            height: this.naturalHeight
          })
        }

        img.onerror = function(err) {
          reject(new Error('图片加载失败'))
        }

        img.src = base64String
      })
    },
    async getDetail (row) {
      this.addReadLog()
      if(row.pagePic){
        this.currentPagePic = this.handleImgUrl(row.pagePic)
      }else{
        this.$message({
          message: '该书缺少对照阅读相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
      }
      const pageJson = JSON.parse(row.pageJson)
      this.currentRow = row
      this.currentRow.picWidth = 0
      this.currentRow.picHeight = 0
      let imageDimensions={}
      if (row.pagePic) {
       /* this.currentRow.picWidth = row.imgSizes['width']
        this.imageSize.width = row.imgSizes['width']
        this.currentRow.picHeight = row.imgSizes['height']
        this.imageSize.height = row.imgSizes['height']*/
        this.containerWidth = this.$refs.container.clientWidth;
        this.containerHeight = this.$refs.container.clientHeight;
        const containerRatio = this.containerWidth / this.containerHeight;
        const imgRatio = this.imageSize.width / this.imageSize.height;
        if (containerRatio > imgRatio) {
          // 容器更宽，高度方向填满
          this.scalRatio=this.containerHeight / this.imageSize.height;
        } else {
          // 容器更高，宽度方向填满
          this.scalRatio= this.containerWidth / this.imageSize.width;
        }
        imageDimensions = await this.getImageDimensions(this.currentPagePic)
        console.log(imageDimensions)
        this.currentRow.picWidth = imageDimensions['width']*this.scalRatio*0.9
        this.currentRow.picHeight = imageDimensions['height']*this.scalRatio*0.9
      }

      this.mainText = row.mainText
      if(row.pageJson){
        let pageJson=JSON.parse(row.pageJson)
        console.log(pageJson)
        if(Array.isArray(pageJson)){
          if(pageJson.length===0){
            this.currentBox=[]
            this.$message({
              message: '该书缺少对照文本数据，请联系管理员或者先查看其他书籍',
              type: 'warning'
            });
          }else{
            let preds=[]
            pageJson.forEach(pageJsonItem=>{
              preds.push({
                bbox:pageJsonItem[0],
                pred:pageJsonItem[1]
              })
            })
            this.currentBox=[{preds:preds}]
          }
        }else{
          if(Object.keys(pageJson).length === 0){
            this.currentBox=[]
            this.$message({
              message: '该书缺少对照文本数据，请联系管理员或者先查看其他书籍',
              type: 'warning'
            });
          }else{
            console.log(pageJson.result[0])
            this.currentBox = pageJson.result[0]
          }
        }
      }else{
        this.currentBox=[]
        this.$message({
          message: '该书缺少对照文本数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
      }
      console.log(this.currentBox)
      this.puncArr={}
      if (row.specialText) {
        // 句读 or 标点
        const specialText = JSON.parse(row.specialText)
        // this.puncArr = specialText.punc.map(item => {
        //   return item.from
        // })
        console.log(specialText)
        specialText.punc.forEach(item => {
          this.puncArr[item.from] = item
        })
        specialText.passage.forEach(item=>{
          this.puncArr[item.from] = this.puncArr[item.from] || {
            from:item.from,
            text:'。',
          }
        })
        // 段落
        let tmpArr = []
        let lastnum = 0
        specialText.passage.forEach(item => {
          tmpArr.push(this.mainText.slice(lastnum, item.from - 1))
          lastnum = item.from - 1
        })
        if (lastnum < this.mainText.length) {
          tmpArr.push(this.mainText.slice(lastnum))
        }
        this.passageArr = []
        let pindex = 1
        this.passageArr = tmpArr.map(item => {
          let tmp = []
          for (let i = 1; i <= item.length; i++) {
            tmp.push({
              id: pindex,
              text: this.mainText[pindex - 1]
            })
            pindex++
          }
          return tmp
        })
        console.log(this.passageArr)
        // 实体
        this.nerArr = {}
        specialText.ner.forEach(item => {
          for (let i = item.from; i <= item.to; i++) {
            this.nerArr[i]=item.type
          }
        })
        console.log(this.nerArr)
        //  词性
        this.posEndArr=[]
        this.posEndObj={}
        this.posArr = specialText.pos.map(item => {
          const tmp = []
          for (let i = item.from; i <= item.to; i++) {
            tmp.push({
              id: i,
              type: item.type
            })
          }
          this.posEndArr.push({
            id: item.to,
            type: item.type
          })

          this.posEndObj[item.to] = item.type
          return tmp
        })
        // 段落
      }
      this.$nextTick(() => {
       /* const container = document.getElementById('picBox')
        // 计算滚动条所能达到的最大值
        const maxScrollX = container.scrollWidth - container.clientWidth
        // 将滚动条移动到最右边
        container.scrollTo(maxScrollX, 0)
        const rightContainer = document.getElementById('opearBox')
        rightContainer.scrollTo(maxScrollX, 0)*/
        // 获取当前可是窗口大小
        if (row.pagePic) {
          this.containerWidth = this.$refs.container.clientWidth;
          this.containerHeight = this.$refs.container.clientHeight;
          const containerRatio = this.containerWidth / this.containerHeight;
          const imgRatio = imageDimensions.width / imageDimensions.height;
          if (containerRatio > imgRatio) {
            // 容器更宽，高度方向填满
            this.scalRatio=this.containerHeight / imageDimensions.height;
          } else {
            // 容器更高，宽度方向填满
            this.scalRatio= this.containerWidth / imageDimensions.width;
          }
          this.currentRow.picWidth = imageDimensions['width']*this.scalRatio* this.canvasRatio
          this.currentRow.picHeight = imageDimensions['height']*this.scalRatio* this.canvasRatio
          //const clientHeight = container.clientHeight
          //this.canvasRatio = clientHeight / row.imgSizes['height']
          //this.currentRow.picWidth = row.imgSizes['width'] * this.canvasRatio
          //this.currentRow.picHeight = clientHeight
          let predId = 1
          this.allText = ''
          this.currentBox = this.currentBox.map((item, index) => {
            item.preds = item.preds.map((pred, pid) => {
              let box = pred.bbox
              let width = parseInt(box[2]) - parseInt(box[0])
              let height = parseInt(box[3]) - parseInt(box[1])
              let left = pred.bbox[0]
              let top = pred.bbox[1]
              if (width !== 0) {
                if (width >= 44) {
                  pred.type = 'header'
                  // pred.font = 40 * this.canvasRatio
                } else if (width >= 25) {
                  pred.type = 'big'
                  // pred.font = 30 * this.canvasRatio
                } else if (width >= 18) {
                  pred.type = 'normal'
                  // pred.font = 18 * this.canvasRatio
                } else {
                  pred.type = 'small'
                  // pred.font = 14 * this.canvasRatio
                }
                pred.font = Math.floor(width - 2) * this.canvasRatio*this.scalRatio
              }
              pred.width = width * this.canvasRatio*this.scalRatio
              pred.height = height * this.canvasRatio*this.scalRatio
              pred.left = left * this.canvasRatio*this.scalRatio
              pred.top = top * this.canvasRatio*this.scalRatio
              pred.juRigth = -(width - 4) * this.canvasRatio*this.scalRatio
              // pred.juTop = -(height - 10) * this.canvasRatio

              pred.juTop = 0 * this.canvasRatio*this.scalRatio
              pred.id = predId
              this.allText = this.allText + converter(pred.pred[0])
              predId++
              return pred
            })
            return item
          })
          this.$nextTick(() => {
            this.resetPic()
            this.handleSearch(this.currentSearchText)
            if (this.$route.query && this.$route.query.keyWordAll && this.isShowKeywordHigh) {
              this.setKeywordHigh()
            }
          })
        }
      })
    },
    computedBgColor (id) {
      let colorResult = ''
      // 右键选中的
      if (this.selectedTextArr.indexOf(id) > -1) {
       // return '#FFF1B9'
        return 'rgb(64, 158, 255,0.5)'
      }
      // 搜索的
      if (this.searchTextIds.indexOf(id) > -1) {
        return '#FF4C5D'
      }
      // 词性
      if (this.isShowPos && this.isUseColor) {
        for (let i = 0; i < this.posArr.length; i++) {
          const ids = this.posArr[i].map(pos => pos.id)
          if (ids.indexOf(id) > -1) {
            colorResult = this.color[this.posArr[i][0]['type']]
            break
          }
        }
      }
      return colorResult
    },
    computedBgColorPic (id) {
      let colorResult = ''
      // 右键选中的
      if (this.selectedTextArr.indexOf(id) > -1) {
        //return 'rgba(255,241,185,0.5)'
        return 'rgb(64, 158, 255,0.5)'
      }
      // 搜索的
      if (this.searchTextIds.indexOf(id) > -1) {
        return 'rgba(255,76,93,0.5)'
      }
      // 词性
      if (this.isShowPos && this.isUseColor) {
        let color = {
          N: 'rgb(67, 205, 63,0.5)',
          T: 'rgb(93, 157, 254,0.5)',
          F: 'rgb(255,186,0,0.5)',
          V: 'rgb(0, 248, 255, 0.5)',

          A: 'rgb(133,89, 93, 0.5',
          D: 'rgb(195, 87, 97, 0.5)',
          M: 'rgb(181 ,87, 195, 0.5)',
          P: 'rgb(98, 78, 159, 0.5)',

          C: 'rgb(78, 133 ,159, 0.5)',
          Y: 'rgb(68, 153 ,194, 0.5)',
          U: 'rgb(122, 206 ,188, 0.5)',
          E: 'rgb(61, 160, 138, 0.5)',
          R: 'rgb(126, 212 ,91, 0.5)',
          W: 'rgb(209,218 ,71, 0.5)'
        }
        for (let i = 0; i < this.posArr.length; i++) {
          const ids = this.posArr[i].map(pos => pos.id)
          if (ids.indexOf(id) > -1) {
            colorResult = color[this.posArr[i][0]['type']]
            break
          }
        }
      }
      return colorResult
    },
    clickSplitPic (index) {
      this.selMap = {}
      this.$set(this.selMap, index, 1)
      this.currentSpiltIndex.splice(0, 1, index)
      this.currentFont = this.currentBox[index].type

      if (this.currentSpiltIndex.length > 0) {
        if (this.currentRow.ocrStatus < 50 && !this.isSort) {
          let textDoc = document.getElementById(
            'text' + this.currentSpiltIndex[0]
          )
          textDoc.focus()
          textDoc.scrollIntoView({ behavior: 'smooth' })
        }
        let picDoc = document.getElementById('pic' + this.currentSpiltIndex[0])
        picDoc.scrollIntoView({ behavior: 'smooth' })
      }
    },
    cancelSel () {
      this.currentSpiltIndex = []
      this.selMap = {}
    },

    resetPic () {
      this.currentSpiltIndex = []
      this.selMap = {}
      this.operaStackList = []
      this.currentStackIndex = 0
      this.operaList = []
      this.isSort = false
      this.ratio = 1
      this.currentSpiltIndexStr = ''
      // this.currentIndex = 0
      // this.rectType = "hidden";
      this.selectedTextArr = []
      this.searchTextIds = []
      this.selectedText = ''
    },

    inputWidth (text, type) {
      let fontsize = 18
      if (type) {
        let temp = variables['jd' + this.titleCase(type) + 'FontSize'].replace(
          'px',
          ''
        )
        fontsize = parseInt(temp)
      }

      let realLen = 0
      if (text.length == 0) {
        realLen = 100
      }
      realLen = text.length * fontsize + 40
      const container = document.getElementById('opearBox')
      let clientWidth = container.clientWidth
      if (realLen > clientWidth) {
        return realLen + 'px'
      }
      return '100%'
    },
    inputHeight (text, type) {
      let fontsize = 18
      if (type) {
        let temp = variables['jd' + this.titleCase(type) + 'FontSize'].replace(
          'px',
          ''
        )
        fontsize = parseInt(temp)
      }

      let realLen = 0
      if (text.length == 0) {
        realLen = 100
      }
      realLen = text.length * fontsize + 40
      const container = document.getElementById('opearBox')
      let clientWidth = container.clientHeight
      if (realLen > clientWidth) {
        return realLen + 'px'
      }
      return '100%'
    },
    inputClass (type) {
      let temp = type
      if (!temp) {
        temp = 'normal'
      }
      let colorClass = 'inputDeep' + this.titleCase(temp)
      // if (this.selMap[index] != undefined) {
      //   colorClass += ' inputDeepSel' + this.titleCase(temp)
      // }
      return colorClass
    },
    textAreaPrepend (text, type) {
      if (!type) {
        type = 'normal'
      }
      return variables['jd' + this.titleCase(type) + 'FontColor']
    },
    picBorderStyle (index) {
      if (this.selMap[index] != undefined) {
        let temp = this.currentBox[index].type
        if (!temp) {
          temp = 'normal'
        }
        return variables['jd' + this.titleCase(temp) + 'FontColor']
      } else {
        if (this.rectType == 'hidden') {
          return 'none'
        } else if (this.rectType == 'white') {
          return variables['jdBorderYellowBackColor']
        } else {
          return variables['jdBorderWhiteBackColor']
        }
      }
    },

    handleRatio (oldRatio) {
      for (let i = 0; i < this.currentBox.length; i++) {
        let box = this.currentBox[i].box
        if (box && box.length > 0) {
          for (let j = 0; j < box.length; j++) {
            box[j] = this.timesFloat(
              box[j],
              this.divFloat(this.ratio, oldRatio, 10),
              10
            )
          }
        }
      }
    },
    handleZoomIn (event) {
      this.handleZoom('in')
    },
    handleZoomOut (event) {
      this.handleZoom('out')
    },
    handleZoom (val) {
      this.isZoom = true
      let ratio = this.ratio
      if (val == 'in') {
        if (this.ratio >= 2) {
          return
        }
        this.ratio = this.sumFloat(ratio, 0.1)
      } else {
        if (this.ratio <= 0.1) {
          return
        }
        this.ratio = this.sumFloat(ratio, -0.1)
      }
      this.selMap = {}
      this.handleRatio(ratio)
    },
    handleRightZoomIn (event) {
      this.handleRightZoom('in')
    },
    handleRightZoomOut (event) {
      this.handleRightZoom('out')
    },
    handleRightZoom (val) {
      this.isZoom = true
      let ratio = this.rightRatio
      if (val == 'in') {
        if (this.rightRatio >= 2) {
          return
        }
        this.rightRatio = this.sumFloat(ratio, 0.1)
      } else {
        if (this.rightRatio <= 0.1) {
          return
        }
        this.rightRatio = this.sumFloat(ratio, -0.1)
      }
      this.selMap = {}
      this.handleRightRatio(ratio)
    },
    handleRightRatio (oldRatio) {
      for (let i = 0; i < this.currentBox.length; i++) {
        let box = this.currentBox[i].box
        if (box && box.length > 0) {
          for (let j = 0; j < box.length; j++) {
            box[j] = this.timesFloat(
              box[j],
              this.divFloat(this.rightRatio, oldRatio, 10),
              10
            )
          }
        }
      }
    },
    // 将数字转换为整数
    toInteger (num) {
      return num * Math.pow(10, 1) // 假设我们需要两位小数
    },

    // 将计算后的整数转换回原来的小数形式
    fromInteger (num) {
      return num / Math.pow(10, 1)
    },
    titleCase (str) {
      return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
    },
    sumFloat (val1, val2) {
      let x = new Big(val1)
      let y = new Big(val2)
      return x.plus(y)
    },

    minusFloat (val1, val2) {
      let x = new Big(val1)
      let y = new Big(val2)
      return x.minus(y)
    },

    timesFloat (val1, val2, fixed) {
      let x = new Big(val1)
      let y = new Big(val2)
      return x.times(y).toFixed(fixed)
    },

    divFloat (val1, val2, fixed) {
      let x = new Big(val1)
      let y = new Big(val2)
      return x.div(y).toFixed(fixed)
    },
    // 拖拽功能
    startDrag (event) {
      // 阻止默认行为
      event.preventDefault()

      // 记录起始点
      const touch = event.type === 'touchstart' ? event.touches[0] : event
      this.startX = touch.clientX - this.currentX
      this.startY = touch.clientY - this.currentY

      // 获取容器边界
      // const dragArea = this.$refs.dragArea
      // const draggableElement = this.$refs.draggableElement
      // this.boundary = {
      //   minX: 0,
      //   minY: 0,
      //   maxX: dragArea.offsetWidth - draggableElement.offsetWidth,
      //   maxY: dragArea.offsetHeight - draggableElement.offsetHeight
      // }

      // 添加事件监听
      this.isDragging = true
      document.addEventListener('mousemove', this.drag)
      document.addEventListener('touchmove', this.drag, { passive: false })
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    drag (event) {
      if (!this.isDragging) return

      // 获取当前鼠标位置
      const touch = event.type === 'touchmove' ? event.touches[0] : event
      let x = touch.clientX - this.startX
      let y = touch.clientY - this.startY

      // 限制图片不能超出边界
      // x = Math.max(this.boundary.minX, Math.min(x, this.boundary.maxX))
      // y = Math.max(this.boundary.minY, Math.min(y, this.boundary.maxY))
      this.throttle(x, y)
    },
    throttle (x, y) {
      const _this = this
      if (!this.timer) {
        this.timer = setTimeout(() => {
          // 更新图片位置
          _this.currentX = x
          _this.currentY = y
          _this.timer = null // 清空定时器
        }, 20)
      }
    },
    stopDrag () {
      this.isDragging = false
      clearTimeout(this.timer)
      this.timer = null
      // 移除事件监听
      document.removeEventListener('mousemove', this.drag)
      document.removeEventListener('touchmove', this.drag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchend', this.stopDrag)
    },
    // 上一页
    handlePre () {
      if (this.currentIndex === 0) {
        return false
      }
      this.currentIndex = this.currentIndex - 1
      this.currentIndexBox = this.currentIndexBox - 1
      if (this.pageArr[this.currentIndex]) {
        this.pageId = this.pageArr[this.currentIndex]
        if (this.pageList && this.pageList[this.currentIndex]) {
          this.getDetail(this.pageList[this.currentIndex])
        } else {
          // this.queryParams.pageNum--
          this.getPageList()
        }

        // this.$nextTick(() => {
        // this.resetPic()
        //   this.handleSearch(this.currentSearchText)
        // })

        this.$emit('setCurrentIndex', this.currentIndex)
      }
    },
    // 下一页
    handleNext () {
      if (this.currentIndex + 1 >= this.total) {
        return false
      }
      this.currentIndex = this.currentIndex + 1
      this.currentIndexBox = this.currentIndexBox + 1
      if (this.pageArr[this.currentIndex]) {
        this.pageId = this.pageArr[this.currentIndex]
        if (!this.pageList[this.currentIndex + 1]) {
          // this.queryParams.pageNum++
          this.getPageList()
        } else {
          this.getDetail(this.pageList[this.currentIndex])
        }
        // this.resetPic()
        // this.$nextTick(() => {
        //   this.handleSearch(this.currentSearchText)
        // })
        this.$emit('setCurrentIndex', this.currentIndex)
      }
    },
    setpage (val) {
      val = Number(val)
      if (val >= 0 && val <= this.total) {
        this.currentIndex = val
        this.currentIndexBox = val+1
        this.pageId = this.pageArr[this.currentIndex]
        if (!this.pageList[this.currentIndex] && (this.currentIndex < this.total)) {
          // this.queryParams.pageNum = Math.ceil(val / this.queryParams.pageSize)
          this.getPageList()
        } else {
          this.getDetail(this.pageList[this.currentIndex])
        }
        // this.resetPic()
        // this.$nextTick(() => {
        //   this.handleSearch(this.currentSearchText)
        // })
        this.$emit('setCurrentIndex', this.currentIndex)
      }
    },
    handleHorizontal () {
      this.isHorizontal = !this.isHorizontal
      if(this.isHorizontal){
        this.rightRatio=1.5
        if(!this.mainText){
          this.$message({
            message: '该书缺少横向阅读数据，请联系管理员或者先查看其他书籍',
            type: 'warning'
          });
         return
        }
      }else{
        this.rightRatio=1
      }
      this.$nextTick(() => {
        this.handleSearch(this.currentSearchText)
        if (this.$route.query && this.$route.query.keyWordAll && this.isShowKeywordHigh) {
          this.setKeywordHigh()
        }
      })
      this.isUseEmpty = false
      this.isUseColor = false
      this.isShowNer = false
    },
    showPunc () {
      if(Object.keys(this.puncArr).length === 0){
        this.$message({
          message: '该书缺少句读相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
        return
      }
      if (this.isShowPunc) {
        this.isShowPunc = false
      } else {
        this.isShowPunc = true
        this.isShowPunc1 = false
      }
    },
    showPunc1 () {
      if(Object.keys(this.puncArr).length === 0){
        this.$message({
          message: '该书缺少标点相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
        return
      }
      if (this.isShowPunc1) {
        this.isShowPunc1 = false
      } else {
        this.isShowPunc = false
        this.isShowPunc1 = true
      }
    },
    showPos () {
      this.isShowPos = true
      this.isShowNer = false
      if (this.isHorizontal) {
        this.isUseEmpty = true
      } else {
        this.isUseColor = true
      }
    },
    showEmpty () {
      if(this.posArr.length===0){
        this.$message({
          message: '该书缺少分词与词性(标签)相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
        return
      }
      if (this.isUseEmpty) {
        this.isUseEmpty = false
      } else {
        this.isShowPos = true
        this.isHorizontal = true
        this.isUseEmpty = true
        this.isUseColor = false
        this.isShowNer = false
      }
    },
    showColor () {
      if(this.posArr.length===0){
        this.$message({
          message: '该书缺少分词与词性(颜色)相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
        return
      }
      if (this.isUseColor) {
        this.isUseColor = false
      } else {
        this.isShowPos = true
        this.isUseColor = true
        this.isUseEmpty = false
        this.isShowNer = false
      }
    },
    showNer () {
      if(Object.keys(this.nerArr).length === 0){
        this.$message({
          message: '该书缺少实体标记相关数据，请联系管理员或者先查看其他书籍',
          type: 'warning'
        });
        return
      }
      if (this.isShowNer) {
        this.isShowNer = false
      } else {
        this.isShowPos = false
        this.isShowNer = true
        this.isUseEmpty = false
        this.isUseColor = false
      }
    },
    goCenter () {
      const routeUrl = this.$router.resolve({ path: '/uc', query: {
          type: this.addFrom
        }})
      window.open(routeUrl.href, '_blank')
    },
    // 添加笔记
    addNote () {
      if (!this.noteForm.remark) {
        this.$message.error('详细描述不能为空')
        return false
      }
      addBookNote({
        noteTarget: this.noteForm.text,
        noteType: 1,
        beginPage: this.currentIndex,
        endPage: this.currentIndex,
        noteContent: this.noteForm.remark,
        bookId: this.bookId
      }).then(res => {
        if (res.code === 200) {
          this.successVisible = true
          this.addFrom='note'
        } else {
          this.$message.error(res.msg)
        }
        this.noteVisible = false
      })
    },
    // 添加书签
    addMark () {
      if (!this.bookMarkForm.remark) {
        this.$message.error('详细描述不能为空')
        return false
      }
      addBookNote({
        noteTarget: this.bookMarkForm.text,
        noteType: 2,
        beginPage: this.currentIndex,
        endPage: this.currentIndex,
        noteContent: this.bookMarkForm.remark,
        bookId: this.bookId
      }).then(res => {
        if (res.code === 200) {
          this.successVisible = true
          this.addFrom=''
        } else {
          this.$message.error('添加失败')
        }
        this.bookMarkVisible = false
      })
    },
    // 添加问题反馈
    addProblem () {
      if (!this.problemForm.remark) {
        this.$message.error('详细描述不能为空')
        return false
      }
      const selectedText = this.problemForm.selectedText.replace(/\n/g, '');
      addBookQa({
        feedbackInfo: this.problemForm.remark,
        beginPage: this.currentIndex,
        endPage: this.currentIndex,
        bookId: this.bookId,
        contentName:selectedText
      }).then(res => {
        if (res.code === 200) {
          this.successVisible = true
          this.addFrom='feedBack'
        } else {
          this.$message.error(res.msg)
        }
        this.problemVisible = false
      })
    },
    // 拼字输入法
    goPartSearch () {
      window.open('http://47.103.198.22:7520/partsearch/', '_blank')
    },
    // 阅读记录
    addReadLog () {
      if (localStorage.token) {
        try {
          read({
            beginPage: parseInt(this.currentIndex),
            endPage: parseFloat(this.currentIndex),
            bookId: this.bookId
          })
        } catch (e) {

        }
      }

    },
    // 阅读记录
    getBookInfo () {
      bookInfo({
        bookId: this.bookId
      }).then(res => {
        if (res.code === 200) {
          this.bookInfo = res.data
          this.$emit('getBookInfo', this.bookInfo)
        } else {
          this.bookInfo = {}
        }
      })
    },
    // 设置字体加粗
    setBold () {
      this.isBold = !this.isBold
      window.localStorage.setItem('isBold', this.isBold)
    },
    // 设置字体斜体
    setItalic () {
      this.isItalic = !this.isItalic
      window.localStorage.setItem('isItalic', this.isItalic)
    },
    handleCopy () {
      this.copyText(this.selectedText.replace(/\s/g, ''), this)
      this.visibleRightMenu = false
    },
    handleCopyBookdetail () {
     let mainText= this.selectedText.replace(/\s/g, '')
      let params=JSON.stringify({
        currentIndex:this.currentIndex + 1,
        text:mainText,
        bookId:this.bookId
      })
      copyRecord({
        param: params,
        operationType:'copy',
        title:'复制'
      }).then(res => {
        if (res.code === 200) {
          // 原文：
          // 出处： 著作者.题名.版本.页数
          const text = '原文：' + this.selectedText.replace(/\s/g, '') + ';'
          const writer = this.bookInfo.writer ? `出处：${this.bookInfo.writer} 著，` : ''
          const bookVersion = this.bookInfo.bookVersion ? `${this.bookInfo.bookVersion},` : ''
          this.copyText(text + writer + `${this.bookName}，` + bookVersion + `第${this.currentIndex + 1}页`, this)
          this.visibleRightMenu = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/variables";
.horizontal-cursor {
  cursor: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="5" viewBox="0 0 16 5"><rect x="0" y="0" width="20" height="2" fill="black"/></svg>') 8 2, text;
}
.reader_right {
  flex: 1;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  padding:10px 20px 20px 20px;
  background-color: rgba(255, 255, 255, 0.8);
  ::selection {
    background: transparent;
  }
  .horizontal_wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    // &>div{
    //   width: 100%;
    //   display: flex;
    //   flex-wrap: wrap;
    // }
  }
  .horizontal_flex {
    display: inline-block;
    align-items: baseline;
  }

  .horizontal_ju {
    color: red;
    font-size: 32px;
  }
  .rightMenu {
    position: fixed;
    /deep/ .el-card__body {
      padding: 0;
    }
    .rightMenu_inner {
      padding: 10px;
      div {
        font-size: 0.94rem;
        color: #666;
        padding: 0.2rem 0;
        margin-bottom: 0.36rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .contentBox {
    margin-top: 5px;
    overflow: hidden;
    .picBox {
      overflow: hidden;
      position: relative;
      display: flex;
      justify-content: center;
      border: 1px solid #ccc;
      border-right: none;
      border-radius: 4px 0 0 4px;
      align-items: center;
      .srcImg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  #opearBox {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .rightInner {
      //padding: 10px;
      flex: 1;
      background-color: #f8f7f3;
      overflow: hidden;
      border: 1px solid #ccc;
      border-radius:0 4px 4px 0;
      display: flex;
      align-items: center;
    }
    //justify-content: center;
  }
  .full_wrapper {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10000;

    .content_img {
      position: relative;
      z-index: 10000;
      display: flex;
      justify-content: center;
      height: 90%;
      overflow: auto;

      img {
        height: 100%;
      }
    }

    .inner {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100vw;
      color: #fff;
    }
  }

  .origintext {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    // height: calc(100vh - 20.3rem);
    // margin-right: 20px;
    overflow: hidden;
  }

  .content {
    flex: 1 1 auto;
    overflow: auto;
  }

  .toolbarwrap {
    display: flex;

    & > div:last-child {
      width: 50%;
    }
  }

  .toolbar {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    //padding-bottom: 12px;
    //border-radius: 8px 0px 0px 8px;
    .barItem:last-child {
      border-right: 1px solid #F3F2EE;
    }

    .barItem {
      // width: 88px;
      // width: 62px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #fff;
      margin-right: 1px;
      cursor: pointer;
      padding: 0 5px;
      margin-bottom: 5px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #2B2B2B;
      border-left: 1px solid #F3F2EE;
      border-top: 1px solid #F3F2EE;
      border-bottom: 1px solid #F3F2EE;
      &:hover {
        font-weight: 500;
        font-size: 10px;
        color: #DBB054;
      }
      &.active {
        font-weight: 500;
        font-size: 10px;
        color: #DBB054;
        border: 1px solid #DBB054;
        &:hover {
          font-weight: 500;
          font-size: 10px;
          color: #DBB054;
        }
      }

      &:nth-child(1) {
        border-radius: 4px 0px 0px 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0px;
      }
    }
    .barItemLast{
      border-right: 1px solid #F3F2EE;
      &.active {
        border-radius: 0 4px 4px 0px;
      }
    }
    .bottombar {
      position: absolute;
      right: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #2B2B2B;
      //padding: 0 10px;
      //border-top: 1px solid rgba(255, 255, 255, 0.8);
      background: #F5EFE6;
      border-radius: 4px;
      margin: 0 10px;
     // margin-top: 16px;
      .page {
        display: flex;
        height: 20px;
        color: #2B2B2B;
        margin-right: 10px;
        .prepage,
        .nextpage {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
          width: 24px;
          background: #F5EFE6;
          border-radius: 4px;
          cursor: pointer;
          color: #000000;
          &.disable {
            color: #ccc;
            cursor: default;
          }
        }
        .pagenum {
          padding: 0 20px;
          font-size: 10px;
          line-height: 20px;
          span {
            font-size: 10px;
            font-weight: 700;
          }
          /deep/.custom-select .el-input__inner {
            height: 18px;
            line-height: 18px;
          }
          /deep/.custom-select  .el-select-dropdown__item {
            height: 18px;
            line-height: 18px;
          }
          /deep/.custom-select .el-input__icon{
            line-height: 18px;
          }
          /deep/.custom-select.el-select .el-input.is-focus .el-input__inner{
            border: 1px solid #DCDFE6;
          }
          /deep/.custom-select .el-input__inner:focus{
            border: 1px solid #DCDFE6;
          }
        }
      }

      .scale {
        display: flex;
        align-items: center;
        height: 20px;
        color: #2B2B2B;
        margin-right: 10px;
        img {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        .icon {
          width: 30px;
        }

        .pagenum {
          padding: 0 20px;
          font-size: 10px;
          height: 20px;
          line-height: 20px;
          span {
            line-height: 20px;
            font-size: 10px;
            font-weight: 700;
          }
        }
      }

      .full {
        display: flex;
        align-items: center;
        height: 20px;
        margin-right: 10px;
        img {
          width: 24px;
          height: 20px;
          cursor: pointer;
        }

        div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
          width: 24px;
          background: rgba(16, 54, 57, 0.1);
          border-radius: 4px;
          cursor: pointer;

          &:first-child {
            margin-right: 20px;
          }
        }
      }
      .style {
        display: flex;
        //margin-right: 10px;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
          width: 24px;
          font-size:15px;
          border-radius: 4px;
          cursor: pointer;
          color: #2B2B2B;
          &.active {
            background: rgba(16, 54, 57, 0.1);
          }
          &:first-child {
            //margin-right: 20px;
            font-weight: 700;
          }
          &:nth-child(2) {
            img {
              width: 15px;
            }
          }
        }
      }
    }
  }


  .success_dialog {
    text-align: center;
    * {
      font-size: 20px;
    }
    & > span {
      vertical-align: middle;
    }
  }
  /deep/ .el-table__body tr.current-row > td {
    border: 2px solid #eb7652;
  }

  /deep/ .inputDeepBorder {
    .unHorizontal {
      border: 1px solid #ebe9df;
      border-radius: 0px;
      text-align: center;
      overflow: hidden;
      color: #070707;
      height: 100%;
      line-height: 1.5;
      padding: 5px 0 0;
      //height: inherit;
      writing-mode: inherit;
    }
    .el-input__inner {
      border: 1px solid #ebe9df;
      border-radius: 0px;
      color: #070707;
      min-width: 100%;
    }

    .el-textarea__inner {
      border: 1px solid #ebe9df;
      border-radius: 0px;
      text-align: center;
      overflow: hidden;
      color: #070707;
      height: 100%;
      padding: 5px 0 0;
      //height: inherit;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0;
    }
  }

  //.inputDeepSel /deep/{
  //  .el-input__inner{
  //    background-color: $jd_sel_background_color;
  //  }
  //  .el-textarea__inner{
  //    background-color: $jd_sel_background_color;
  //  }
  //}

  /deep/ .inputDeepSelHeader {
    .el-input__inner {
      background-color: @jd_header_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      background-color: @jd_header_font_color;
    }
  }

  /deep/ .inputDeepSelBig {
    .el-input__inner {
      background-color: @jd_big_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      background-color: @jd_big_font_color;
    }
  }

  /deep/ .inputDeepSelNormal {
    .el-input__inner {
      background-color: @jd_normal_font_color;
    }

    .el-textarea__inner {
      background-color: @jd_normal_font_color;
    }
  }

  /deep/ .inputDeepSelSmall {
    .el-input__inner {
      background-color: @jd_small_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      background-color: @jd_small_font_color;
    }
  }
  .ju {
    position: absolute;
    color: red;
  }
  /deep/ .inputDeepHeader {
    .el-input__inner,
    .horizontal {
      // line-height: @jd_header_font_size * (3/2);
      // height: 60px;
      font-size: @jd_header_font_size;
      //color: @jd_header_font_color;
    }

    .el-textarea__inner,
    .unHorizontal,
    .ju {
      // font-size: @jd_header_font_size;
      font-size: 40px;
      // width: 52px;
    }
    .unHorizontal {
      position: relative;
      z-index: 1;
    }
    .ju {
      position: absolute;
      right: -33px;
      // top:-26px;
      z-index: 0;
      color: red;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0;
      width: 2px;
      background-color: @jd_header_font_color;
    }
  }

  /deep/ .inputDeepBig {
    .el-input__inner,
    .horizontal {
      // line-height: @jd_big_font_size * (3/2);
      // height: 48px;
      font-size: @jd_big_font_size;
      //color: @jd_big_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      font-size: 30px;
      // width: 42px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0;
      width: 2px;
      background-color: @jd_big_font_color;
    }
  }

  /deep/ .inputDeepNormal {
    .el-input__inner,
    .horizontal {
      // line-height: @jd_normal_font_size * (3/2);
      // height: 40px;
      font-size: @jd_normal_font_size;
      //color: @jd_normal_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      font-size: @jd_normal_font_size;
      // width: 36px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0;
      width: 2px;
      background-color: @jd_normal_font_color;
    }
  }

  /deep/ .inputDeepSmall {
    .el-input__inner,
    .horizontal {
      // line-height: @jd_small_font_size * (3/2);
      // height: 36px;
      font-size: @jd_small_font_size;
      //color: @jd_small_font_color;
    }

    .el-textarea__inner,
    .unHorizontal {
      font-size: @jd_small_font_size;
      // width: 25px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0;
      width: 2px;
      background-color: @jd_small_font_color;
    }
  }

  .title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .drag-box {
    position: absolute;
    left: 0;
    top: 0;
    cursor: ew-resize;
    width: 8px;
    height: 100%;
    z-index: 999;
  }

  .cover {
    width: 100%;
    height: 100%;
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .flex-row-reverse {
    display: flex;
    flex-direction: row-reverse;
  }

  .open-icon {
    position: absolute;
    right: 24px;
    top: 14px;
    width: 24px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .relative {
    position: relative;
  }

  .flex {
    display: flex;
  }

  .flex-grow1 {
    flex: 1;
    flex-grow: 1;
  }

  .justify-between {
    display: flex;
    justify-content: space-between;
  }

  .align-start {
    display: flex;
    align-items: flex-start;
  }

  .align-center {
    display: flex;
    align-items: center;
  }

  .align-right {
    display: flex;
    align-items: flex-end;
  }

  .auto-scroll {
    overflow: auto;
  }

  .tree-list {
    padding: 5px 12px;
    width: 250px;
    background: rgba(112, 112, 112, 0.04);
    /*height: 100vh - 6.9rem;*/
    overflow-y: scroll;
    position: relative;

    .drag-box {
      left: initial;
      right: 0;
    }

    img {
      width: 24px;
      //margin-bottom: 10px;
    }
  }

  .text-opera {
    // width: 50%;
    /*height: ~ "calc(100vh - 7rem)";*/
    position: relative;
    // border-style: ridge;
    // overflow: hidden;
  }

  .sel-border {
    //border-color: @jd_sel_background_color;
    border-style: solid;
    border-width: 3px;
  }

  .default-border {
    border-style: solid;
    border-width: 2px;
  }

  .sort-border {
    border: 1px solid #b49159;
  }

  .new-border {
    border-color: yellow;
    border-style: ridge;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/components/rightContainer.vue